import ContentGearTip from './ContentGearTip'

export default ContentGearTip
